export default {
  screens: [
    {
      type: 'intro',
      title: 'CHAUMET与东瀛文化的渊源',
      content:
        'CHAUMET与东瀛文化的渊源可追溯至品牌创立之时。这种兴趣是相互的，因为众多日本顾客也选择了CHAUMET。',
      idYt: 'vGycDLMlTz4',
      videoCover: 'world/japan/video.jpg',
      desktop: {
        cover: 'world/japan/cover-1.jpg'
      },
      mobile: {
        cover: 'world/japan/mobile-cover-1.jpg',
        contentStyle: {
          width: '100%'
        },
        coverStyle: {
          width: '100%',
          bottom: '0%',
          left: '0',
          right: 'inherit',
          position: 'relative'
        }
      }
    },
    {
      type: 'triangle',
      desktop: {
        topImg: 'world/japan/triangleTop.jpg',
        btmImg: 'world/japan/triangleBtm.jpg',
        cover: 'world/japan/cover-2.jpg'
      },
      mobile: {
        topImg: 'world/japan/mobileTriangleTop.jpg',
        btmImg: 'world/japan/triangleBtm.jpg'
      },
      content:
        '早在大革命期间，尼铎便赞誉并惊叹于玛丽·安托瓦内特皇后所藏日本天然漆器饰品，这种关注一直延续到当代作品中。<br/><br/> CHAUMET的珠宝艺术创作受到日本风格的启发，随后一直延续至今。CHAUMET创作了“樱之漫歌”高级珠宝套系。'
    },
    {
      type: 'column',
      leftImg: 'world/japan/columnLeft.jpg',
      middleImg: 'world/japan/columnMiddle.jpg',
      rightImg: 'world/japan/columnRight.jpg',
      title: 'Song of Spring',
      content:
        '本次高级珠宝套系将极富几何结构的设计与桀骜不驯的动感元素完美融合，是堪称融汇法式文化与东瀛和风的天成之作。宝石仿如多彩调色板上的红色（红宝石、铁镁铝石榴石）和黑色（缟玛瑙）般错落搭配，加以钻石的璀璨光芒点亮整体，充分实现两种自然主义传统的交融贯通。'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/cn/worlds/japan.js